var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 30.0187C6 16.7536 16.7536 6 30.0187 6C43.2839 6 54.0375 16.7536 54.0375 30.0187C54.0375 43.2839 43.2839 54.0375 30.0187 54.0375C16.7536 54.0375 6 43.2839 6 30.0187Z",
    fill: "#0C9347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 36L33 30.5L27 25",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleRight);
export default __webpack_public_path__ + "static/media/ArrowCircleRight.8a1d92a701cf38afcb74c570d79dac02.svg";
export { ForwardRef as ReactComponent };